/**
 * O menu MAXIMIZADO por cima do chat (§5.1; pedido do usuário, 14/09/2026):
 * quando a faixa ao lado do trilho não cabe o menu (a tela mostra a régua
 * `compacta`), o chevron do topo da régua abre a `condensada` SOBREPOSTA
 * às bolhas — largura normal, `right: 16px`, sombra de camada. Estado LOCAL
 * (`maximizado`, não persiste; quem apaga a preferência de régua é o
 * `expandir` do pai). Sai do sobreposto: pelo "Recolher" do cabeçalho
 * (volta à régua, sem gravar preferência), com ESC, com clique fora — ou
 * sozinho quando a faixa passa a caber (lateral recolhida): aí o menu vira
 * o normal, sem a classe.
 *
 * Listeners no `document` só enquanto está sobreposto; limpos ao fechar e
 * em `beforeDestroy`. `mousedown` (não `click`): o clique que fecha não
 * vaza ao que está embaixo. Mixin do `chat-indice-artefatos.vue`, que dá
 * `larguraMaxima`, `visao` e `VISOES_DO_INDICE` — separado só pelo teto de
 * 500 linhas do componente.
 */
import { cabeMenuNaFaixa } from './chat-indice-artefatos.constantes'

const TECLA_ESC = 'Escape'

export default {
  data() {
    return {
      maximizado: false,
    }
  },
  computed: {
    cabeMenu() {
      return cabeMenuNaFaixa(this.larguraMaxima)
    },
    // Só é "sobreposto" o menu aberto por cima SEM faixa e SEM a preferência
    // de régua — com faixa o mesmo `maximizado` não significa nada.
    sobreposto() {
      return this.maximizado && !this.cabeMenu && !this.prefereRegua
    },
  },
  watch: {
    sobreposto(ativo) {
      if (ativo) {
        document.addEventListener('mousedown', this.recolherSeFora)
        document.addEventListener('keydown', this.recolherComEsc)
        return
      }
      this.desligarFechamentoDoSobreposto()
    },
    // A faixa passou a caber: o menu é o normal a partir daqui.
    cabeMenu(cabe) {
      if (cabe) this.maximizado = false
    },
    // Lista esvaziou (troca de conversa: `limparArtefatosDaConversa`): a
    // decisão local morre com a conversa — a próxima não pode nascer
    // sobreposta por herança.
    temLinhas(tem) {
      if (!tem) this.recolher()
    },
  },
  beforeDestroy() {
    this.desligarFechamentoDoSobreposto()
  },
  methods: {
    maximizar() {
      this.maximizado = true
    },
    recolher() {
      this.maximizado = false
    },
    desligarFechamentoDoSobreposto() {
      document.removeEventListener('mousedown', this.recolherSeFora)
      document.removeEventListener('keydown', this.recolherComEsc)
    },
    recolherSeFora(evento) {
      if (this.$el && this.$el.contains && this.$el.contains(evento.target)) return
      this.recolher()
    },
    recolherComEsc(evento) {
      if (evento.key !== TECLA_ESC) return
      this.recolher()
    },
  },
}
